.UnitExperienceBar {
  overflow: hidden;
  background-color: #f0ead6;
  position: relative;
  border-width: 0.05em;
  border-color: #000222;
  border-style: solid;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.UnitExperienceBar[isVisible=true] {
  opacity: 1;
}
.UnitExperienceBar .Fill {
  width: 0%;
  height: 100%;
  z-index: 10;
  position: absolute;
  background-color: #62C370;
  transition-property: width;
  transition-duration: 0.1s;
}
